/**
 * Partners Marquee Handler
 *
 * Detects if partner logos overflow their container and enables
 * a seamless marquee animation when they don't fit in a single row.
 */
const partnersMarquee = () => {
	const list = document.querySelector('.partners__list');
	if (!list) return;

	const check = () => {
		// Temporarily disable marquee to measure natural content width
		list.classList.remove('is-marquee');

		// Get the container width (the parent .container or .partners)
		const container = list.closest('.container') || list.parentElement;
		const containerWidth = container.clientWidth;

		// Sum up the widths of original (non-duplicate) items + gaps
		const items = list.querySelectorAll(
			'.partners__item:not(.partners__item--duplicate)'
		);
		if (!items.length) return;

		const gap = parseFloat(getComputedStyle(list).gap) || 0;
		let totalWidth = 0;

		items.forEach((item) => {
			totalWidth += item.offsetWidth;
		});

		// Add gaps between items
		totalWidth += gap * (items.length - 1);

		// If content overflows — enable marquee
		if (totalWidth > containerWidth) {
			list.classList.add('is-marquee');
		}
	};

	// Run on load and resize
	check();
	window.addEventListener('resize', check);
};

export default partnersMarquee;
